// video component meant to be included in another

import { FC, useCallback, useState } from 'react'
import cx from 'classnames'

import { VideoYoutubeProps } from '../VideoYoutube'

import * as SC from './styled'

export type VideoSingleProps = VideoYoutubeProps & {
  className?: string
}

const VideoSingle: FC<VideoSingleProps> = ({
  className,
  transcriptProps,
  ...videoToutubeProps
}) => {
  const [openTranscript, setOpenTranscript] = useState(false)
  const toggleTranscript = useCallback(
    () => setOpenTranscript(!openTranscript),
    [openTranscript]
  )
  return (
    <SC.Container className={cx('VideoSingle', className)}>
      <SC._VideoYoutube {...videoToutubeProps} />
      {transcriptProps && (
        <SC._Transcript
          {...transcriptProps}
          open={openTranscript}
          toggleHandler={toggleTranscript}
        />
      )}
    </SC.Container>
  )
}

export default VideoSingle
